{
    "ReportingMenu_FirstClosePopup": "Para reabrir o menu, clique no botão \"Relatórios\" na barra lateral enquanto estiver na página Relatórios.",
    "NAME": "ReportingMenuLanguage"
}